import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { User} from 'src/app/Model/User/user.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  loading = false;
  returnUrl: string;
  submitted = false;
  error;
  currentUser:User;
  
  constructor( private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private _authenticationService: AuthenticationService) { 
      try {
        this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
        if(this.currentUser!=null){
             
         
          this.redirectUser(this.currentUser.role);
        
      }
      } catch (error) {
        
      }
    
    }

  ngOnInit(): void {

    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
  });
 
  // get return url from route parameters or default to '/'
  this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/main-dashboard';
  }

  
  
  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
        return;
    }

    this.loading = true;
    this._authenticationService.login(this.f.username.value, this.f.password.value)
        .pipe(first())
        .subscribe(
            data => {
        
           
              this.router.navigate([this.returnUrl]);
                        
          
           
             // console.log(data.branch);
            
         this.redirectUser(data.role);
             this.loading = false;
            },
            error => {
              this.loading = false;
                this.error = error;
                this.loading = false;
            });
}




redirectUser(userRole) {
  console.log(userRole);
  if (userRole == UserRole.Signage) {
    this.router.navigate(['/main-signage-dashboard']);
  }else if (userRole == UserRole.Device) {
    this.router.navigate(['/welcome']);
  }else if (userRole == UserRole.PowerUser) {
    this.router.navigate(['/main-dashboard']);
  } else if (userRole == UserRole.Administrator) {
    this.router.navigate(['/main-dashboard']);
  } else if (userRole == UserRole.Employee) {
      this.router.navigate(['../employee-details', { extra: this._authenticationService.currentUserValue.userName, extra1:this._authenticationService.currentUserValue.firstName, extra2:this._authenticationService.currentUserValue.lastName }], { relativeTo: this.route });
  } else if (userRole == UserRole.SystemAdministrator) {
    this.router.navigate(['/main-dashboard']);
   
  }else if (userRole == UserRole.Management) {
    this.router.navigate(['/main-dashboard']);
  }else if (userRole == UserRole.Receptionist) {
    this.router.navigate(['/main-dashboard']);
  }else if (userRole == UserRole.SalesRepresentative) {
    this.router.navigate(['/sales-rep-home']);
  }else if (userRole == UserRole.SalesSupport) {
    this.router.navigate(['/sales-rep-home']);
  }else if (userRole == UserRole.User) {
    this.router.navigate(['/main-dashboard']);
  }else if (userRole == UserRole.Manager) {
    this.router.navigate(['/main-dashboard']);
  }else if (userRole == UserRole.Reporter) {
    this.router.navigate(['/main-dashboard']);
  }else if (userRole == UserRole.Shipper) {
    this.router.navigate(['/logistics-main']);  
  }

}


}
